import { createStore } from "vuex";

export const notifStore = createStore({
  state: () => {
    return {
      title: "",
      message: "",
      autoHide: 0,
      status: null,
      visible: false,
      onClose: null,
    };
  },

  mutations: {
    create(state, notif) {
      state.title = notif.title;
      state.message = notif.message;
      state.status = notif.status;
      state.visible = true;
      state.autoHide = notif.autoHide;
      state.onClose = notif.onClose || null;
    },

    show(state) {
      state.visible = true;
    },

    hide(state) {
      const callback = state.onClose;
      state.visible = false;
      state.message = "";
      state.onClose = null;
      
      // Call onClose callback after hiding
      if (callback && typeof callback === 'function') {
        callback();
      }
    },
  },

  actions: {
    create({ commit }, notif) {
      commit("create", notif);
    },

    show({ commit }) {
      commit("show");
    },

    hide({ commit }) {
      commit("hide");
    },
  },
});
